module.exports = __webpack_public_path__ + "static/img/solution-4.adf8f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution-4.png
// module id = b9on
// module chunks = 0